export default __webpack_public_path__ + "static/media/brCEB.ffa37afb.png";